module.exports = __webpack_public_path__ + "img/fbcolor.38c811d8.png";